<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 26 32"
  >
    <g>
      <path
        fill="#fff"
        d="M4.384 22.054c-2.235-2.268-3.615-5.383-3.615-8.82s1.38-6.553 3.617-8.822l-0.001 0.002c2.218-2.254 5.302-3.651 8.713-3.651 0.011 0 0.023 0 0.034 0h-0.002c0.005 0 0.010 0 0.015 0 3.415 0 6.505 1.397 8.727 3.65l0.001 0.001c2.235 2.268 3.615 5.383 3.615 8.82s-1.38 6.553-3.617 8.822l-8.706 8.854z"
      />
      <path
        fill="#464646"
        d="M13.128 1.588c0.004 0 0.010 0 0.015 0 3.191 0 6.078 1.304 8.157 3.408l0.001 0.001c2.090 2.099 3.382 4.995 3.382 8.192 0 0.016-0 0.032-0 0.048v-0.002c0 0.009 0 0.019 0 0.030 0 3.202-1.292 6.103-3.383 8.209l0.001-0.001-8.136 8.266-8.21-8.276c-2.090-2.099-3.382-4.995-3.382-8.192 0-0.016 0-0.032 0-0.048v0.002c-0-0.009-0-0.019-0-0.030 0-3.202 1.292-6.103 3.383-8.209l-0.001 0.001c2.081-2.1 4.966-3.4 8.155-3.4 0.006 0 0.013 0 0.019 0h-0.001zM13.128-0.001c-0.004 0-0.009 0-0.014 0-3.627 0-6.908 1.483-9.269 3.875l-0.001 0.001c-2.376 2.404-3.843 5.71-3.843 9.359s1.468 6.955 3.845 9.36l-0.001-0.001 9.322 9.406 9.248-9.396c2.376-2.404 3.843-5.71 3.843-9.359s-1.468-6.955-3.845-9.36l0.001 0.001c-2.362-2.399-5.645-3.886-9.275-3.886-0.004 0-0.007 0-0.011 0h0.001z"
      />
      <path
        fill="#464646"
        d="M22.746 11.742l-9.618 2.882-9.627-2.882 9.627-2.891z"
      />
      <path
        fill="#464646"
        d="M13.128 15.561l-4.818-1.504v2.648c0 0.99 2.152 1.792 4.818 1.792s4.818-0.802 4.818-1.792v-2.648z"
      />
      <path
        fill="#464646"
        d="M7.321 15.976c0 0.527-0.428 0.955-0.955 0.955s-0.955-0.428-0.955-0.955c0-0.527 0.428-0.955 0.955-0.955s0.955 0.428 0.955 0.955z"
      />
      <path fill="#464646" d="M6.779 15.895h-0.838l-0.532 4.458h1.909z" />
      <path
        fill="#464646"
        d="M6.834 15.372h-0.946c0-1.198 0.126-2.441 1.63-3.35l0.487 0.811c-1.081 0.666-1.171 1.504-1.171 2.54z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
